import React, { Component } from 'react';

import ContactUsForm from './contact-us';

import './contact-us.scss';

const defaultState = {
    
}

class ContactUS extends Component {
    constructor(props) {
        super(props);
        this.state = defaultState;

    }
    
    render() {
        const show  = this.props.show === true ? 'block' : 'none';
        return ( 
            <ContactUsForm 
                show={show}
                handleClose={this.props.handleClose}
                closeModal={this.props.closeModal}
            /> 
        );
    }
}

export default ContactUS;


// WEBPACK FOOTER //
// ./src/components/contact-us/index.js